<div class="container">
  <a (click)="url= null" class="icon" *ngIf="url !== null">
    <i class="bx bx-reset"></i> Rest the flowchart
  </a>
  <img *ngIf="url !== null" alt="screenshot"  src="{{url}}" >



  <div class="tools-container" *ngIf="url == null" >
    <div id="buttons">
      <div
        (click)="newNode(); clearMessage();"
        class="resizable node-tool"
        title="cliquer pour ajouter">
      </div>
      <span>Etape</span>
      <div
        (click)="newDecisionNode(); clearMessage();"
        class="resizable rhombus-parent"
        title="cliquer pour ajouter">
        <div class="rhombus-tool"></div>
      </div>
      <span>Décision</span>
      <div
        (click)="newEndNode(); clearMessage();"
        class="resizable end-tool"
        title="cliquer pour ajouter">
        <i class='bx bxs-circle'></i>
      </div>
      <span>Fin</span>


    </div>

    <div class="options">
      <div
        (click)="save()"
        class="resizable end-tool"
        title="Save">
        <i class='bx bxs-arrow-to-bottom'></i>
      </div>
      <div
        (click)="delete()"
        class="resizable end-tool"
        title="Delete">
        <i class='bx bx-trash'></i>
      </div>
      <div
        (click)="edit()"
        class="resizable end-tool"
        title="Edit">
        <i class='bx bx-edit'></i>
      </div>
      <div
        (click)="reset()"

        class="resizable end-tool"
        title="Reset">
        <i class='bx bx-reset'></i>
      </div>

    </div>
  </div>

  <div class=" dotted-bg" id="graph-display" *ngIf="url == null" >
    <div
      class="position-absolute zindex10"
      (click)="clickId2(node.id); newEdge()"
      (dblclick)="clickId(node.id); newEdge()"
      (mousedown)="mouseDown($event, node)"
      *ngFor="let node of nodes"
      [id]="node.getId()"
      [ngClass]="{'end' : node.type == itemsTypes.end, 'node': node.type == itemsTypes.process }"
      [style.background-color]="node.type !== itemsTypes.decision ?  node.bg: 'transparent'"
      cdkDrag
      cdkDragBoundary="#graph-display"
    >

      <div *ngIf="node.type == itemsTypes.decision" class="rhombus">
        <div *ngIf="!node.modifiable" class="rhombus-text">   {{node.getValue()}}</div>
        <input (keyup.enter)="onEnter(node.id, $event)"
               *ngIf="node.modifiable && node.type == itemsTypes.decision"
               [style.height.px]="node.getRadius()*2"
               [value]="node.getValue()" class="input-box rhombus-text"
               placeholder="ecrire ..."
               type="text">
        <div *ngIf="!node.modifiable" cdkDragHandle
             class="rh-handle">
          <svg fill="currentColor" viewBox="0 0 24 24" width="24px">
            <path
              d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
            <path d="M0 0h24v24H0z" fill="none"></path>
          </svg>
        </div>

      </div>


      <div *ngIf="node.type === itemsTypes.process && !node.modifiable" cdkDragHandle
           class="drag-handle">
        <svg fill="currentColor" viewBox="0 0 24 24" width="24px">
          <path
            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </div>


      <div *ngIf="!node.modifiable && node.type !== itemsTypes.decision" class="">   {{node.getValue()}}</div>
      <i *ngIf="node.type == itemsTypes.end" class='bx bxs-circle'> </i>

      <input (keyup.enter)="onEnter(node.id, $event)"
             *ngIf="node.modifiable && node.type == itemsTypes.process"
             [style.height.px]="node.getRadius()*2" [value]="node.getValue()" class="input-box"
             type="text">

    </div>


    <div (click)="clickEdgeId(edge.id);"
         (dblclick)="changeValue(edge)"
         *ngFor="let edge of edges; let i = index"
         [style.cursor]="'pointer'"
         [style.left.px]="centerX(edge.nodes[0], edge.nodes[1])"
         [style.top.px]="centerY(edge.nodes[0], edge.nodes[1])"
         [style.transform]="'rotate(' + angle(edge.nodes[0], edge.nodes[1]) + 'deg)'"
         [style.width.px]="length(edge.nodes[0], edge.nodes[1])"
         class="edge"
         title="double clique pour ecrire">

      <span>{{edge.value}}</span>
      <input (keyup.enter)="onEdgeEnter(edge.id, $event)"
             *ngIf="edge.modifiable"
             class="edge-text"
             placeholder="ecrire ici"
             type="text">

    </div>

  </div>

</div>

